export default [{
  text: '组件名称',
  name: 'name',
}, {
  text: '链接',
  name: 'url',
  trim: true,
}, {
  text: '短链',
  name: 'needShortUrl',
  inputType: 'switch',
}, {
  text: '邀请有礼',
  name: 'inviteGift',
  inputType: 'switch',
  defaultValue: false,
  onChange(vm, v, { model }) {
    // 开启后默认切换至有礼客人态链接
    if (v) {
      // eslint-disable-next-line no-param-reassign
      model.url = 'https://film.qq.com/weixin/v3/invite-reward/guest.html?ptag=usercenter.invite';
    }
  },
}, {
  type: 'component',
  id: 'devConfig',
}, {
  type: 'component',
  id: 'rect',
}];
